// removed by extract-text-webpack-plugin
module.exports = {"timeBarWrapper":"src-components-Header-__timeBar-module___timeBarWrapper","timeBarHeading":"src-components-Header-__timeBar-module___timeBarHeading","timeBarNumber":"src-components-Header-__timeBar-module___timeBarNumber","timeBarTitle":"src-components-Header-__timeBar-module___timeBarTitle","timeBar":"src-components-Header-__timeBar-module___timeBar","progressBar":"src-components-Header-__timeBar-module___progressBar","timeBarButton":"src-components-Header-__timeBar-module___timeBarButton"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/timeBar.module.css
// module id = 1521
// module chunks = 0